<template>
  <v-dialog v-model="displayForm" persistent max-width="1024px">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title>
          <span class="headline">Add Prescription</span>
        </v-card-title>
        <v-alert
          :value="message"
          type="error"
          dismissible
          transition="scale-transition"
          >{{ message }}</v-alert
        >
        <prescription-form
          :prescription="model"
          v-model="model"
          v-on:create="create()"
        ></prescription-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="cancel()"
            :disabled="loading"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="create()"
            :disabled="loading"
            >Create</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import PrescriptionForm from "@components/prescriptions/PrescriptionForm.vue";

function getDefaultData() {
  return {
    model: {
      clientId: null,
      locationId: null,
      clubFitterId: null,
      fittingTypeId: null,
      shipping_id: null,
      shopZoneId: null,
      fittingDate: null,
      currencyId: null,
      taxRateId: null,
      orderId: null,
      shopId: null,
      isConvertibleToOrder: null,
      isQuotable: null,
      isModifiable: true,
    },
    items: [],
    mandatoryRules: [(v) => !!v || "This fiels is mandatory"],
    message: null,
    valid: null,
    datePicker: false,
    loading: false,
  };
}
export default {
  components: {
    PrescriptionForm,
  },
  props: {
    open: {},
  },
  data: getDefaultData,
  computed: {
    displayForm: function() {
      return this.open;
    },
  },
  methods: {
    create() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store
          .dispatch("prescriptions/add", {
            model: this.model,
          })
          .then(({prescription}) => {
            this.$emit("add", prescription.id);
            this.resetForm();
          })
          .catch(result => {
            this.message = result.message;
          })
          .finally(() => (this.loading = false));
      }
    },
    cancel() {
      this.$emit("cancel");
      this.resetForm();
    },
    resetForm() {
      Object.assign(this.$data, getDefaultData());
      this.$refs.form.reset();
    },
  },
};
</script>

<style></style>
